import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-player-migration',
  templateUrl: './player-migration.component.html',
  styleUrls: ['./player-migration.component.scss'],
})

export class PlayerMigrationComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  public title: string;

  constructor(
    public configService: ConfigService,
    public logoutService: LogoutService,
    public navigator: Navigator,
    public webcontentService: WebcontentService,
  ){
  }

  ngOnInit(): void {
    const url: string = this.getURL();
    this.webcontentService.updateExternalLink(url);
    this.title = this.configService.getExternalLinks().payload.filter(link => link?.code == "player_migration")[0]?.title ?? 'Welcome to Stardust';
  }

  public getURL(): string{
    return this.configService.getExternalLinks().payload.filter(link => link?.code == "player_migration")[0]?.url ?? 'player-migration';
  }

  public onContinue(){
    return this.navigator.navigateTo('PlayerMigrationActionComponent', { multipleModals: true });
  }

  onClose = () => {
    this.logoutService.callLogout();
  }

}
